import script from "./item7.vue?vue&type=script&setup=true&lang=js"
export * from "./item7.vue?vue&type=script&setup=true&lang=js"

import "./item7.vue?vue&type=style&index=0&id=2c081353&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c081353"]])

export default __exports__